export class BackupZeroEtlIdentityColumnSpec {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "field",
            "baseName": "field",
            "type": "BackupZeroEtlIdentityColumnField",
            "format": ""
        },
        {
            "name": "columnName",
            "baseName": "columnName",
            "type": "string",
            "format": ""
        },
        {
            "name": "partition",
            "baseName": "partition",
            "type": "boolean",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return BackupZeroEtlIdentityColumnSpec.attributeTypeMap;
    }
    constructor() {
    }
}
